import React from 'react'
import { BasePage } from './BasePage'
import { Reports } from './Reports'

export const ReportPage = () => {
  return (
    <React.Fragment>
      <BasePage Comp={Reports} />
    </React.Fragment>
  )
}
